module.exports = __webpack_public_path__ + "static/media/ninos_checked.8b6e05ee.svg";